import React,{useEffect} from "react";
import { RouterProvider, createBrowserRouter, useNavigate } from "react-router-dom";
import HomeRoute from "./Routes/HomeRoute";
import VideoRoute from "./Routes/VideoRoute";
import LoginRoute from "./Routes/LoginRoute";
import SubscriptionPage from "./Routes/SubscriptionPage";
import OtpValidationPage from "./Routes/OtpValidationPage";
import Cookies from 'js-cookie';
import Subscription from "./Components/Subscription";

const RedirectToExternalOrHome = ({ url }) => {
  const navigate = useNavigate();

  // React.useEffect(() => {
  //   // Check if the cookie exists
  //   const user = Cookies.get('user')
  //   const new_user = Cookies.get('new_user_without_login')
  //   if (!user || user == null || user == undefined || user == " ") {
  //     Cookies.set('user','subscribed')
  //     Cookies.set('new_user_without_login','no_login',{expires:1});
  //     window.location.href = url;
  //   } else if( user == 'subscribed'  ) {
  //     navigate('/home');
  //   }
  // }, [navigate, url]);

// commented latest


  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   console.log(params.size,'PARAMS')
  //   let queryParams = {};
  //   for (let [key, value] of params.entries()) {
  //     queryParams[key] = value;
  //   }
  //   // setQueryParams(queryParams);

  //   if(params.size == 0 || queryParams.ext_ref == null || queryParams.ext_ref == undefined || queryParams.ext_ref == ''){
  //     navigate('/login')
  //   }

  //   else {
  //     console.log(queryParams, 'dgfgcvhbjn');
  
  //     // Function to log headers and then redirect
  //     function logHeadersAndRedirect() {
  //         fetch('/headers', {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json'
  //             },
  //             body: JSON.stringify({
  //                 headers: {
  //                     'User-Agent': navigator.userAgent, // Example header
  //                     'Language': navigator.language, // Example header
  //                     // Add more headers as needed
  //                 },
  //             }),
  //             keepalive: true // Ensures request completes even if page unloads
  //         })
  //         .then((response) => {
  //             if (response.ok) {
  //                 // Redirect to external URL after logging
  //                 window.location.href = url;
  //             } else {
  //                 console.error('Failed to log headers');
  //                 window.location.href = url; // Redirect anyway if logging fails
  //             }
  //         })
  //         .catch((error) => {
  //             console.error('Error logging headers:', error);
  //             window.location.href = url; // Redirect anyway if logging fails
  //         });
  //     }
  
  //     // Call the function to log headers and redirect
  //     logHeadersAndRedirect();
  // }


  //   // else{
  //   //   window.location.href = url;
  //   // }
   
  // }, []);


  // useEffect(()=>{
  //   //check for logged in cookie
  //   const referrer = document.referrer;
  //   console.log(referrer)
  //     if (referrer){
        
  //       var referrerHostname = new URL(referrer).hostname;
  //       // setReferrer(referrerHostname)
  //       console.log(`The user was referred from: ${referrerHostname}`);

  //       if( referrerHostname == 'bmd.go2oh.net'){
  //          window.location.href = url;
  //       }


  //     } else {
  //       console.log('The user accessed the site directly');
  //       const loginCookie = Cookies.get('logged_in');
  //       if(!loginCookie || loginCookie == '' || loginCookie == null || loginCookie == undefined){
  //          navigate('/login');
  //       }
  //       else{
  //         const numberCookie = Cookies.get('kidszonepro_user');
  //         console.log(numberCookie)
  //         if(!numberCookie || numberCookie == '' || numberCookie == null || numberCookie == undefined){
  //           navigate('/login')
  //         }
  //         else{
  //           console.log(numberCookie)
  //           // navigate('/home');
  //         }
  //       }
  //     }
  // },[])


  return null;
};

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <LoginRoute />
    },

    {
      path: "/subscribe",
      element: <Subscription />
    },

    // {
    //   path: "/",
    //   element: <RedirectToExternalOrHome url={`http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3DdQ%3D%3D`} />, // Redirect from "/"
    // },
    {
      path: "/",
      element: <HomeRoute />,
    },
    {
      path: "/video/:id",
      element: <VideoRoute />
    },
    {
      path: "/otp",
      element: <SubscriptionPage />,
    },
    {
      path: "/otp-validation",
      element: <OtpValidationPage />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
